import { PleditorPlugin } from '../PleditorPlugin';
export class UserPermissions extends PleditorPlugin {
    static get requires() {
        return ['Permissions'];
    }
    init() {
        this.userPermissions.setPermissions(['document:write', 'comment:write']);
    }
}
